import React from 'react'

export const replaceCityActivityPlaceHoldersInFaq = ({ txt, city, zip }) => {
  return txt
    .split('[ville]')
    .join(city)
    .split('[code-postal]')
    .join(zip)
}
export const replaceItineraryPlaceHoldersInFaq = ({ txt, cityA, cityB }) => {
  return txt
    .split('[villeA]')
    .join(cityA)
    .split('[villeB]')
    .join(cityB)
}

export const replaceCityActivityPlaceHoldersAndLinksInFaq = ({ txt, city, zip, currentRouteURL }) => {
  return insertLinkInText({ txt: replaceCityActivityPlaceHoldersInFaq({ txt, city, zip }), currentRouteURL })
}

export const replaceItineraryPlaceHoldersAndLinksInFaq = ({ txt, cityA, cityB, currentRouteURL }) => {
  return insertLinkInText({ txt: replaceItineraryPlaceHoldersInFaq({ txt, cityA, cityB }), currentRouteURL })
}

export const insertLinkInText = ({ txt, currentRouteURL }) => {
  // we use the <a>##link</a> to build the links
  return txt.split(/<a>(.*?)<\/a>/).map((part, index) => {
    return part.includes('##') ? (
      <a href={currentRouteURL} key={index}>
        {part.substring(2)}
      </a>
    ) : (
      part
    )
  })
}
